/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '@pages/mana/components/Content';


export const loadTableAsync = createAsyncThunk(
  'page/loadTable',
  async function ({ fn, params }: { fn: InitFn; params: any }) {
    const { data } = await fn(params);
    return {
      list: data.dataList,
      total: data.totalCount,
      pageNum: params?.pageNum,
      pageSize: params?.pageSize,
      params
    };
  });

export const resetParams = createAsyncThunk(
  'page/resetParams',
  async function ({ fn, params }: { fn: InitFn; params: any }) {
    const { data } = await fn(params);
    return {
      list: data.dataList,
      total: data.totalCount,
      totalCount: data.totalCount,
      pageNum: params?.pageNum,
      pageSize: params?.pageSize,
      params
    };
  });

export const pageChange = createAsyncThunk(
  'page/resetParams',
  async function ({ fn, params }: { fn: InitFn; params: any }) {
    const { data } = await fn(params);
    return {
      list: data.dataList,
      total: data.totalCount,
      totalCount: data.totalCount,
      pageNum: params.pageNum,
      pageSize: params.pageSize
    };
  });

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    resetState (state) {
      Object.assign(state, initialState);
    },
    setParams (state, { payload }) {
      state.params[payload.fieldName] = payload.value;
    },
    addDrawer (state) {
      state.drawerMode = 'add';
      state.showDrawer = true;
    },
    updateDrawer (state, { payload = {} }) {
      state.drawerMode = 'update';
      state.formFields = payload;
      state.showDrawer = true;
    },
    closeDrawer (state) {
      state.drawerMode = undefined;
      state.showDrawer = false;
    },
    previewDrawer (state, { payload = {} }) {
      state.drawerMode = 'preview';
      state.formFields = payload;
      state.showDrawer = true;
    },
    changeFormMode (state, { payload }) {
      state.drawerMode = payload;
    }
  },
  extraReducers: build => {
    build
      .addCase(loadTableAsync.pending, state => {
        state.loading = true;
      })
      .addCase(loadTableAsync.fulfilled, (state, { payload }) => {
        Object.assign(state, payload);
        state.loading = false;
      })
      .addCase(loadTableAsync.rejected, (state) => {
        state.loading = false;
      })
      .addCase(resetParams.pending, state => {
        state.loading = true;
      })
      .addCase(resetParams.fulfilled, (state, { payload }) => {
        Object.assign(state, payload);
        state.loading = false;
      })
      .addCase(resetParams.rejected, state => {
        state.loading = false;
      });
  }
});

export const {
  resetState,
  closeDrawer,
  addDrawer,
  previewDrawer,
  updateDrawer,
  changeFormMode,
  setParams
} = pageSlice.actions;

export default pageSlice;